(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easytabs-liquid-tab-2"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize product overview cards with enhanced accessibility
    const productOverviewCards = document.querySelectorAll('.product-overview__card');

    productOverviewCards.forEach(card => {
      // Make cards keyboard focusable for accessibility
      card.setAttribute('tabindex', '0');

      // Handle keyboard interaction
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    // Optimize images when they enter the viewport
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            observer.unobserve(img);
          }
        });
      });

      document.querySelectorAll('.product-overview__card-icon[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }

    // Add subtle animation effects for better UX
    const animateCards = () => {
      const cards = document.querySelectorAll('.product-overview__card');
      cards.forEach((card, index) => {
        setTimeout(() => {
          card.classList.add('is-visible');
        }, 80 * index);
      });
    };

    // Run animations when section becomes visible
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCards();
          sectionObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    const overviewSection = document.querySelector('.product-overview');
    if (overviewSection) {
      sectionObserver.observe(overviewSection);
    }

    // Handle section editor events for Shopify theme editor
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId.includes('productoverview')) {
        animateCards();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productoverview"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Initialize product overview cards with enhanced accessibility
  const productOverviewCards = document.querySelectorAll('.product-overview__card');
  
  productOverviewCards.forEach(card => {
    // Make cards keyboard focusable for accessibility
    card.setAttribute('tabindex', '0');
    
    // Handle keyboard interaction
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
  
  // Optimize images when they enter the viewport
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    });
    
    document.querySelectorAll('.product-overview__card-icon[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
  
  // Add subtle animation effects for better UX
  const animateCards = () => {
    const cards = document.querySelectorAll('.product-overview__card');
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.add('is-visible');
      }, 80 * index);
    });
  };
  
  // Run animations when section becomes visible
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCards();
        sectionObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  
  const overviewSection = document.querySelector('.product-overview');
  if (overviewSection) {
    sectionObserver.observe(overviewSection);
  }
  
  // Handle section editor events for Shopify theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('productoverview')) {
      animateCards();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
